import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=d82fe5e2&"
import script from "./BookingStatus.vue?vue&type=script&lang=ts&"
export * from "./BookingStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports